import { wrapper } from "@/redux/Store";

import EndUserLicenseAgreementPage from "@/containers/StaticPages/EndUserLicenseAgreement";
import { renderMetaData } from "@/utils";
const EndUserLicenseAgreement = () => {
  const metaData = {
    title: "Shyft end user license agreement",
    description: "Shyft end user license agreement",
  };

  const metaTags = renderMetaData(metaData);
  return (
    <>
      {metaTags}
      <main>
        <EndUserLicenseAgreementPage />
      </main>
    </>
  );
};

export default EndUserLicenseAgreement;

export const getStaticProps = wrapper.getStaticProps(() => async () => {
  return {
    props: {},
    revalidate: 60 * 60 * 24 * 15, // revalidate in 15 days
  };
});
